import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { EventLog } from 'components/common/events';

export default connect((state) => state)(
  class extends Component {
    state = {
      courses: null
    };

    componentDidMount() {
      this.getCourses();
    }

    getCourses = async () => {
      const {
        dispatch,
        pageState: { user }
      } = this.props;

      try {
        const courses = await api.get(
          `/admin/users/${user.id}/participated-courses`
        );
        this.setState({
          courses: courses.data.courses
        });
      } catch (err) {
        this.setState({ loading: false });
        await dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const {
        pageState: { user }
      } = this.props;

      const { courses } = this.state;

      return (
        <div className="events">
          <EventLog courses={courses} userId={user.id} />
        </div>
      );
    }
  }
);
